import { jsx as _jsx } from "react/jsx-runtime";
import '@hotmart-org-ca/cosmos/dist/content-loader';
export function ContentLoader({ count, className, ...props }) {
    return Array.from({ length: count ?? 1 }).map((_, index) => (_jsx("hot-content-loader", { class: className, role: "status", ...props }, index)));
}
